import { createPluginCSSVar } from '../utils';
import { PLUGIN_NAME } from './constants';

export function createCSSVar(variableName: string) {
  return createPluginCSSVar(PLUGIN_NAME, variableName);
}
